import { gql } from '@apollo/client';

export const ParagraphActivityPoiPoisInRegionFragment = gql`
  fragment ParagraphActivityPoiPoisInRegion on ParagraphActivityPoiPoisInRegion {
    id
    title
  }
`;
